import { v4 as uuidv4 } from 'uuid';
import { ParameterNode } from '../types/record/ParameterNode';
export class ParameterNodeBuilder {
    id;
    value;
    key;
    metadata;
    constructor(id, key, value) {
        this.id = id;
        this.key = key;
        this.value = value;
    }
    static fromValue(id, key, value) {
        return new ParameterNodeBuilder(id, key, value);
    }
    static fromNode(node) {
        return new ParameterNodeBuilder(node.id, node.key, node.value);
    }
    setKey(key) {
        this.key = key;
        return this;
    }
    setMetadata(metadata) {
        this.metadata =
            metadata instanceof Map ? metadata : new Map(Object.entries(metadata));
        return this;
    }
    build() {
        const parameterNode = new ParameterNode(this.id || uuidv4(), this.value, this.key, this.metadata);
        return parameterNode;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyYW1ldGVyTm9kZUJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2J1aWxkZXIvUGFyYW1ldGVyTm9kZUJ1aWxkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsSUFBSSxNQUFNLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFHbkMsT0FBTyxFQUFFLGFBQWEsRUFBa0IsTUFBTSwrQkFBK0IsQ0FBQTtBQUU3RSxNQUFNLE9BQU8sb0JBQW9CO0lBQy9CLEVBQUUsQ0FBUTtJQUNWLEtBQUssQ0FBRztJQUNSLEdBQUcsQ0FBUTtJQUNYLFFBQVEsQ0FBVztJQUVuQixZQUFvQixFQUFVLEVBQUUsR0FBVyxFQUFFLEtBQVE7UUFDbkQsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUE7UUFDWixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNkLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3BCLENBQUM7SUFFTSxNQUFNLENBQUMsU0FBUyxDQUNyQixFQUFVLEVBQ1YsR0FBVyxFQUNYLEtBQVE7UUFFUixPQUFPLElBQUksb0JBQW9CLENBQUksRUFBRSxFQUFFLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0lBRU0sTUFBTSxDQUFDLFFBQVEsQ0FDcEIsSUFBc0I7UUFFdEIsT0FBTyxJQUFJLG9CQUFvQixDQUFJLElBQUksQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDbkUsQ0FBQztJQUVELE1BQU0sQ0FBQyxHQUFXO1FBQ2hCLElBQUksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFBO1FBQ2QsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRUQsV0FBVyxDQUFDLFFBQXNEO1FBQ2hFLElBQUksQ0FBQyxRQUFRO1lBQ1gsUUFBUSxZQUFZLEdBQUcsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUE7UUFDeEUsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRUQsS0FBSztRQUNILE1BQU0sYUFBYSxHQUFHLElBQUksYUFBYSxDQUNyQyxJQUFJLENBQUMsRUFBRSxJQUFJLE1BQU0sRUFBRSxFQUNuQixJQUFJLENBQUMsS0FBSyxFQUNWLElBQUksQ0FBQyxHQUFHLEVBQ1IsSUFBSSxDQUFDLFFBQVEsQ0FDZCxDQUFBO1FBQ0QsT0FBTyxhQUFhLENBQUE7SUFDdEIsQ0FBQztDQUNGIn0=